import { HTMLElementBase } from './HTMLElementBase';
import {HTMLElement} from "./HTMLElement";
export class HTMLLegendElement extends HTMLElement { constructor(tagName: string = 'LEGEND', ownerDocument?: any) { super(tagName, ownerDocument); } }
